import React, { useEffect, useState } from 'react';
import {
  TUIKit,
  TUIConversationList,
  TUIChat,
  TUIChatHeader,
  TUIMessageList,
  TUIMessageInput,
  TUIProfile,
  TUIConversation,
  TUIManage,
  TUIContact,
  TUIContactInfo,
  i18next,
  t,
} from '@tencentcloud/chat-uikit-react';
import TencentCloudChat, { ChatSDK } from '@tencentcloud/chat';
import { TUIStore, StoreName, TUIConversationService } from "@tencentcloud/chat-uikit-engine";

import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';
import './style.scss';
import chats from './assets/image/chats.svg';
import chats_selected from './assets/image/chats-selected.svg';
import contacts from './assets/image/contacts.svg';
import contacts_selected from './assets/image/contacts-selected.svg';

import TUIChatEmpty from './TUIChatEmpty';
import { sampleResources } from '../locales/index';

interface ITasks {
  [key: string]: boolean;
}

export default function SocialDemo(props: any) {
  const {
    handleTaskList,
    className
  } = props;
  
  const botConversationList = ['TUILiveKitDemo001', 'AK3PWmVXZu3ByVOE', 'KZJb8oATrgUnETai'];
  const [moduleValue, setModuleValue] = useState("chats");
  const [chat, setChat] = useState<ChatSDK>();
  const [currentLanguage, setCurrentLanguage] = useState<string>('en');

  const tabbarList = [
    {
      id: 1,
      name: 'chats',
      icon: chats,
      selectedIcon: chats_selected,
      value: 'chats'
    },
    {
      id: 2,
      name: 'contacts',
      icon: contacts,
      selectedIcon: contacts_selected,
      value: 'contacts'
    }
  ];
  useEffect(() => {
    TUIStore.watch(StoreName.APP, {
      tasks: (tasks: ITasks) => {
        if(tasks.sendMessage) {
          handleTaskList("send");
        }
        if(tasks.revokeMessage) {
          handleTaskList("recall");
        }
      },
    });
  }, []);
  
  useEffect(() => {
    setCurrentLanguage(i18next.language);
    if (props?.chat) {
      const { chat } = props;
      setChat(chat);
    }
    if (i18next.language === 'zh') {
      i18next.addResources(i18next.language, 'translation', sampleResources?.zh);
    } else {
      i18next.addResources(i18next.language, 'translation', sampleResources?.en);
    }
    
  }, [props, i18next.language]);

  const handleCreateConversation = async (params: string | any) => {
    // create c2c conversation
    if (typeof params === "string") {
      const { data } = await chat?.getConversationProfile(params);
      handleTaskList("startChat");
      return data.conversation;
    }

    // create group conversation
    const {
      name,
      type,
      groupID,
      introduction,
      notification,
      avatar,
      maxMemberNum,
      joinOption,
      memberList = [],
      groupCustomField = [],
    } = params;
    const res = await chat?.createGroup({
      name,
      type,
      groupID,
      introduction,
      notification,
      avatar,
      maxMemberNum,
      joinOption,
      memberList,
      groupCustomField,
    });
    const { groupID: createdGroupID } = res.data.group;
    if (type === TencentCloudChat.TYPES.GRP_AVCHATROOM) {
      await chat?.joinGroup({
        groupID: createdGroupID,
        type: TencentCloudChat.TYPES.GRP_AVCHATROOM,
      });
    }
    const { data } = await chat?.getConversationProfile(
      `GROUP${createdGroupID}`
    );
    handleTaskList("createGroupChat");
    return data.conversation;
  };

  const deleteConversation = async (conversationID: string) => {
    handleTaskList("deleteChat");
    return chat?.deleteConversation(conversationID);
  };

  const filterConversation = (conversationList: Array<any>) => {
    return conversationList.filter((item)=>{
      return item.type !== TencentCloudChat.TYPES.CONV_SYSTEM && !botConversationList.includes(item.conversationID);
    })
  };
  const switchTabbar = (value: string) => {
    setModuleValue(value);
    TUIConversationService.switchConversation('');
  };

  return (
    <div className={`sample-chat ${className}`}>
      <TUIKit language={currentLanguage}>
        <div className="sample-chat-left-container">
          <TUIProfile className="sample-chat-profile" />
          <div className="sample-chat-tab">
            {tabbarList.map((item: any) => {
              return (
                <div
                  className="sample-chat-tab-container"
                  key={item.id}
                  onClick={() => {
                    switchTabbar(item.value);
                  }}
                >
                  <img
                    src={
                      moduleValue === item.value ? item.selectedIcon : item.icon
                    }
                    alt=""
                  />
                  <p
                    className={`sample-chat-tab-text ${
                      moduleValue === item.value ? "sample-chat-tab-active" : ""
                    }`}
                  >
                    {t(item.name)}
                  </p>
                </div>
              );
            })}
          </div>
          {moduleValue === "chats" && (
            <TUIConversation
              createConversation={handleCreateConversation}
              deleteConversation={deleteConversation}
            >
              <TUIConversationList filterConversation={filterConversation} />
            </TUIConversation>
          )}
          {moduleValue === "contacts" && <TUIContact />}
        </div>
        {moduleValue === "chats" && (
          <>
            <TUIChat
              EmptyPlaceholder={<TUIChatEmpty />}
            >
              <TUIChatHeader />
              <TUIMessageList />
              <TUIMessageInput />
            </TUIChat>
            <TUIManage></TUIManage>
          </>
        )}
        {moduleValue === "contacts" && (
          <TUIContact>
            <TUIContactInfo
              showChats={() => {
                setModuleValue("chats");
              }}
            ></TUIContactInfo>
          </TUIContact>
        )}
      </TUIKit>
    </div>
  );
}
